import { CheckCircle2, XCircle } from "lucide-react";
import { AlpanaDivider } from "@/components/tss/Ornaments";
import { ShareCard } from "@/components/tss/ShareCard";

export const Confirmation = ({ receipt, cats, coms, onChange }) => {
  const catName = (id) => cats.find((c) => c.id === id);
  const comName = (id) => coms.find((c) => c.id === id)?.name || "—";
  return (
    <section data-testid="confirmation-screen" className="rise mx-auto max-w-2xl px-4 py-8">
      <div className="grain overflow-hidden rounded-3xl border border-gold bg-white shadow-festive">
        <div className="brush-maroon px-6 pb-10 pt-8 text-center text-ivory">
          <CheckCircle2 className="pop mx-auto h-12 w-12 text-gold-light" />
          <h2 className="mt-3 font-display text-3xl font-bold">Votes recorded</h2>
          <p className="mt-1 font-bengali text-lg text-ivory/90">আপনার ভোট গৃহীত হয়েছে</p>
        </div>
        <div className="px-5 pb-6 pt-2">
          <AlpanaDivider className="mb-4" />
          <ul className="space-y-3" data-testid="confirmation-list">
            {receipt.accepted.map((p) => {
              const cat = catName(p.category_id);
              return (
                <li key={p.category_id} className="flex items-start gap-3 rounded-xl bg-ivory p-3" data-testid={`confirmation-item-${cat?.key || p.category_id}`}>
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-forest" />
                  <div className="min-w-0">
                    <p className="text-xs font-semibold uppercase tracking-wider text-ink-muted">{cat?.name_en} · <span className="font-bengali normal-case tracking-normal">{cat?.name_bn}</span></p>
                    <p className="mt-0.5 font-display text-lg font-bold text-maroon">{comName(p.committee_id)}</p>
                  </div>
                </li>
              );
            })}
            {receipt.rejected.map((id) => (
              <li key={id} className="flex items-start gap-3 rounded-xl bg-red-50 p-3 text-sm" data-testid={`confirmation-rejected-${catName(id)?.key || id}`}>
                <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-maroon" />
                <span>Already voted in <b>{catName(id)?.name_en}</b> — your first vote stands.</span>
              </li>
            ))}
          </ul>
          <div data-testid="confirmation-change-notice" className="mt-4 rounded-xl border-2 border-gold bg-gold/10 p-3 text-center text-sm">
            <p className="font-semibold">Only your LAST vote will be counted.</p>
            <p data-testid="confirmation-changes-remaining">
              {receipt.changes_remaining > 0
                ? `Vote changes remaining: ${receipt.changes_remaining} — you can change your vote ${receipt.changes_remaining} more time${receipt.changes_remaining === 1 ? "" : "s"} (3 submissions total).`
                : "You have used all your vote changes. This is your final vote."}
            </p>
          </div>
          <ShareCard confirmation={receipt.confirmation} />
          <p className="mt-5 text-center text-sm text-ink-muted">Shubho Sharodiya! শুভ শারদীয়া</p>
          {receipt.changes_remaining > 0 && (
            <button type="button" onClick={onChange} data-testid="confirmation-change-vote-btn" className="mt-4 h-12 w-full rounded-full border-2 border-maroon font-semibold text-maroon transition-transform active:scale-95">
              Change my vote
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export const ClosedView = ({ leaderboard }) => (
  <section data-testid="voting-closed" className="rise mx-auto max-w-2xl px-4 py-10 text-center">
    <div className="rounded-3xl border border-gold bg-white px-6 py-10 shadow-festive">
      <h2 className="font-display text-3xl font-bold text-maroon">Voting is closed</h2>
      <p className="mt-2 font-bengali text-lg">ভোটগ্রহণ বন্ধ হয়েছে</p>
      <AlpanaDivider className="my-5" />
      <p className="text-sm text-ink-muted">Thank you to everyone who voted for People's Choice. Results will be announced by TSS.</p>
      {leaderboard && (
        <a href="/leaderboard" data-testid="closed-leaderboard-link" className="mt-6 inline-block rounded-full bg-gold px-6 py-3 font-semibold text-maroon-deep">
          See the leaderboard
        </a>
      )}
    </div>
  </section>
);
